/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type AlertType = (typeof AlertType)[keyof typeof AlertType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlertType = {
  min: "min",
  max: "max",
  soglia1: "soglia1",
  soglia2: "soglia2",
  soglia3: "soglia3",
  soglia4: "soglia4",
  offline: "offline",
} as const;
